import React, { useState, useEffect } from 'react';
import "./airports.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import airport1 from "../../../Assets/airports.jpg";
import { Link } from 'react-router';
import airport2 from "../../../Assets/sound-barrier-india.webp";
import airport3 from "../../../Assets/airports/boarding-bridge-connected-airplane.jpg";
import airport4 from "../../../Assets/sound-barrier-manufacturer.webp";
import airport5 from "../../../Assets/airports/airport-1.jpg";
import airport6 from "../../../Assets/airports/airports-2.png";
import airport7 from "../../../Assets/airports/airports-3.png";
import airport8 from "../../../Assets/airports/airports-4.png";
import airport9 from "../../../Assets/airports/airports-5.png";
import airport10 from "../../../Assets/airports/airports-6.png";
import airport11 from "../../../Assets/airports/airports-7.png";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function Airports() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.air-header,.air-header1,.air-header2,.air-header3,.air-header4,.air-header5,.air-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
    return (
        <>
        <HNavbar />
            <section id='airports' className='home-airports'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-airport'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid airport-home-img' src={airport1} alt="airport-pros" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='air-header'>Airport Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Airports generate high levels of noise from aircraft engines, ground support equipment, generators, and maintenance operations. Sound Barrier Manufacture provides advanced airport noise control solutions using high-performance sound barrier blankets and industrial acoustic barriers.</p>
                            <p className='white-para'>Our airport sound barrier systems are designed to reduce noise transmission outside operational zones and minimize public disturbance in nearby residential and commercial areas.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >

            <section id='airports'>
                <div className='container noice-control mt-4'>
                    <h1 className='air-header1'>Why Noise Control is Important in Airports</h1>
                    <p>Airport environments operate 24/7 and produce continuous high-decibel sound. Without proper noise control systems, this can lead to:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={airport2} alt="airports-pros" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <ul className='list'>
                                <li>Public disturbance complaints</li>
                                <li>Environmental noise regulation issues</li>
                                <li>Community impact concerns</li>
                                <li>Worker exposure to excessive noise</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing professional airport noise barriers helps maintain regulatory compliance and community safety.</p>

                    <h1 className='air-header2' style={{ marginTop: "10px" }}>Our Airport Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies heavy-duty sound barrier blankets and temporary acoustic enclosures suitable for airport projects.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Weather-resistant and UV-stable outer layer</li>
                                <li>Fire-retardant options available</li>
                                <li>Suitable for outdoor and high-wind areas</li>
                                <li>Easy installation on fencing and steel frames</li>
                                <li>Reusable and long-lasting material</li>
                            </ul>
                            <p>Our solutions are designed for both temporary and semi-permanent airport noise control applications.</p>
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex align-items-center justify-content-center'>
                            <img className='img-fluid' src={airport3} alt="airports-pros" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='air-header3' style={{ marginTop: "30px" }}>Benefits of Airport Sound Barriers</h1>
                    <p>Using airport noise control systems helps:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={airport4} alt="airports-pros" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <ul className='list'>
                                <li>Reduce noise pollution around airport boundaries</li>
                                <li>Protect nearby residential communities</li>
                                <li>Meet environmental noise standards</li>
                                <li>Improve operational safety</li>
                                <li>Enhance airport reputation and compliance</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='air-header4' style={{ marginTop: "20px" }}>Applications in Airport Projects</h1>
                    <h4 className='sub-title mt-3'>Our airport noise control systems are ideal for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport5} alt="Aircraft maintenance areas" />
                            <p>Aircraft maintenance areas</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport6} alt="Ground support equipment zones" />
                            <p>Ground support equipment zones</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport7} alt="Generator and compressor enclosures" />
                            <p>Generator and compressor enclosures</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport8} alt="Runway construction projects" />
                            <p>Runway construction projects</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport9} alt="Airport expansion projects" />
                            <p>Airport expansion projects</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport10} alt="Hangar noise control" />
                            <p>Hangar noise control</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={airport11} alt="Temporary construction" />
                            <p>Temporary construction at airport premises</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id='airports' className='call'>
                <div className='container'>
                    <h1 className='air-header5'>Why Choose Us?</h1>

                    <ul className='air-list white-para'>
                        <li>Experienced industrial noise control provider</li>
                        <li>High-performance airport sound barrier systems</li>
                        <li>Custom size and thickness options</li>
                        <li>Fast supply and installation support</li>
                        <li>Cost-effective outdoor noise control solutions</li>
                    </ul>
                    <p className='white-para'>We understand the importance of reducing public disturbance while maintaining smooth airport operations.</p>

                    <h1 className='air-header6'>Contact Us for Airport Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <p className='white-para'>Looking for reliable airport noise control systems?</p>
                            <p className='white-para'>Sound Barrier Manufacture provides customized sound barrier solutions designed to control high-decibel airport noise and protect surrounding communities.</p>
                            <p className='white-para'>Contact us today for expert consultation and airport noise control support.</p>
                        </div>
                        <div className='col-sm-12 col-md-6 p-0'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}
export default Airports